import state from './uiState.js'
import mutations from './uiMutations.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions: {},
  getters: {}
}

